<app-dialog [(visible)]="visible"
            header="Nouvel utilisateur" width="580px"
            [dismissableMask]="false" styleClass="create-user-dialog">

  <form [formGroup]="form" (ngSubmit)="submitCreate()" class="create-form">

    @if (createError()) {
      <div class="error-banner">
        <i class="pi pi-exclamation-circle"></i>
        {{ createError() }}
      </div>
    }

    <!-- Type de compte ─────────────────────────────────────────────────── -->
    <div class="field-wrap">
      <label class="field-label">Type de compte <span class="req">*</span></label>
      <p-selectButton formControlName="accountType" [options]="accountTypeOptions"
                       optionLabel="label" optionValue="value" class="full-field"></p-selectButton>
    </div>

    <div class="fields-row">
      <div class="field-wrap">
        <label class="field-label">Prénom <span class="req">*</span></label>
        <input pInputText formControlName="firstName" placeholder="Prénom" class="full-field" />
        @if (form.get('firstName')?.touched && form.get('firstName')?.hasError('required')) {
          <p class="field-error">Le prénom est requis</p>
        }
      </div>
      <div class="field-wrap">
        <label class="field-label">Nom <span class="req">*</span></label>
        <input pInputText formControlName="lastName" placeholder="Nom" class="full-field" />
        @if (form.get('lastName')?.touched && form.get('lastName')?.hasError('required')) {
          <p class="field-error">Le nom est requis</p>
        }
      </div>
    </div>

    <div class="fields-row">
      <div class="field-wrap">
        <label class="field-label">Email <span class="req">*</span></label>
        <input pInputText type="email" formControlName="email" placeholder="email@exemple.com" class="full-field" />
        @if (form.get('email')?.touched && form.get('email')?.hasError('required')) {
          <p class="field-error">L'email est requis</p>
        }
        @if (form.get('email')?.touched && form.get('email')?.hasError('email')) {
          <p class="field-error">Format d'email invalide</p>
        }
      </div>
      <div class="field-wrap">
        <label class="field-label">Téléphone <span class="req">*</span></label>
        <input pInputText formControlName="phone" placeholder="+225 …" class="full-field" />
        @if (form.get('phone')?.touched && form.get('phone')?.hasError('required')) {
          <p class="field-error">Le téléphone est requis</p>
        }
      </div>
    </div>

    @if (isProfessionnel) {
      <div class="fields-row">
        <div class="field-wrap">
          <label class="field-label">Raison sociale <span class="req">*</span></label>
          <input pInputText formControlName="companyName" placeholder="Nom de l'entreprise" class="full-field" />
          @if (form.get('companyName')?.touched && form.get('companyName')?.hasError('required')) {
            <p class="field-error">La raison sociale est requise pour un compte professionnel</p>
          }
        </div>
        <div class="field-wrap">
          <label class="field-label">NIF</label>
          <input pInputText formControlName="nif" placeholder="Numéro d'identification fiscale" class="full-field" />
        </div>
      </div>
    }

    <div class="field-wrap">
      <label class="field-label">Mot de passe <span class="req">*</span></label>
      <div class="password-row">
        <p-password formControlName="password" [feedback]="false" [toggleMask]="true" class="full-field" placeholder="Mot de passe"></p-password>
        <button pButton type="button" [outlined]="true" icon="pi pi-refresh" pTooltip="Générer un mot de passe" (click)="generatePassword()"></button>
      </div>
      @if (form.get('password')?.touched && form.get('password')?.hasError('required')) {
        <p class="field-error">Le mot de passe est requis</p>
      }
      @if (form.get('password')?.touched && form.get('password')?.hasError('minlength')) {
        <p class="field-error">Minimum 8 caractères</p>
      }
      <p class="field-hint">Le compte est créé directement activé — l'admin se porte garant, pas de vérification OTP.</p>
    </div>

  </form>

  <div dialogFooter>
    <button pButton [text]="true" (click)="close()" label="Annuler"></button>
    <button pButton type="submit" (click)="submitCreate()" class="btn-save"
            [disabled]="form.invalid || saving()" [loading]="saving()"
            icon="pi pi-plus-circle" label="Créer l'utilisateur"></button>
  </div>
</app-dialog>
